import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STATUSES = [
  { value: "order_received", label: "Order Received" },
  { value: "in_production", label: "In Production" },
  { value: "ready_to_dispatch", label: "Ready to Dispatch" },
  { value: "dispatched", label: "Dispatched" },
  { value: "delivered", label: "Delivered" },
];

export const hasRole = (user, ...roles) =>
  !!user && Array.isArray(user.roles) && roles.some((r) => user.roles.includes(r));

export const LOGO_URL = "/dcn-logo.jpg";

export default api;
